export default __webpack_public_path__ + "static/karolinal-40619794d2dabe5bd53d97b18111e28f.png";